import {Box, Grid} from "@mui/material";

export default function  Page404() {
    return (
        <Box sx={{width:'90vw'}}>
            <Grid
                container
                direction="column"
                justifyContent="center"
                alignItems="center">

                <Grid item>
                    <img src='/assets/images/404.jpg' width="1000" />
                </Grid>

            </Grid>
        </Box>
    );
}